import React from 'react';
import {Button} from "@mui/material";

const CecisComponent = (props) => {
    return (
         <div style={styles.cecis}>
             <img src={`./cecis.png`} width={80} style={{float: 'left'}} />
             <b>Olá!</b> <br/>
             Vou te ajudar a criar a documentação e sprint do projeto no Redmine. <br/>
             <b>Selecione a baixo o projeto.</b>
         </div>
    );
};

const styles = {
    cecis: {
        margin: '20px',
        fontSize: '20px',
    }
}

export {CecisComponent};
